<app-table
  #pendingTable
  [captionTemplate]="bulkActionsTemplate"
  [cols]="cols"
  [lazy]="false"
  [elements]="pending"
  modelName="Composições"
  dataKey="compositionId"
  [showHeader]="true"
  [showTitle]="false"
  [exportExcel]="false"
  [exportPdf]="false"
  [addButton]="false"
  [rowSelectable]="rowSelectable"
  [actionButtons]="actionButtons"
  (actionButtonClick)="callAction($event)"
>
  <ng-template #bulkActionsTemplate>
    <div class="bulk-actions" *ngIf="selectedCount">
      <span>{{ selectedCount }} selecionada(s)</span>
      <p-button
        label="Preparar selecionadas"
        icon="pi pi-play"
        styleClass="p-button-success"
        (onClick)="confirmPrepareSelected()"
      />
      <p-button
        label="Excluir selecionadas"
        icon="pi pi-trash"
        severity="danger"
        (onClick)="confirmDeleteSelected()"
      />
    </div>
  </ng-template>
</app-table>
<p-toast />
<p-confirmPopup></p-confirmPopup>
<p-confirmDialog></p-confirmDialog>
